import ScrollContainer from 'react-indiana-drag-scroll';
import styled, { css } from 'styled-components';

export const GraphicCotationHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 68vw;
  max-width: 100%;
  /* width: 100%; */

  .TooltipContentGraphic {
    display: flex;
    flex-direction: column;
    background: ${(props) => props.theme.white};
    border-radius: 4px;

    header {
      background: ${(props) => props.theme['gray-100']};
      padding: 0.5rem;
      color: ${(props) => props.theme.white};
    }
    div {
      padding: 0.5rem;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
  }
`;

export const HeaderGraphic = styled(ScrollContainer)`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: auto;
  align-items: center;
  margin-left: 0;
  box-shadow: 1px 1px 6px 0px rgba(48, 63, 75, 0.42);
  border-radius: 8px;
  padding: 1rem;

  .fechamento {
    display: flex;
    flex-direction: column;
    align-items: center; /* <- estica elementos com width: 100% */
    margin-left: 0; /* <- remove o deslocamento lateral */
    .text-variation {
      margin-left: 0;
      font-size: 0.75rem;
      color: ${(props) => props.theme['gray-500']};
      white-space: normal; /* Permite a quebra */
      line-height: 1.2; /* Melhor leitura */
    }
    b {
      border-bottom: 1px solid var(--Gray-gray-100,rgb(184, 185, 187));
    }

    h1 {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      align-items: center;
      font-weight: 500;
      font-size: 3rem;
      color: ${(props) => props.theme['gray-600']};
      margin-left: 0;
    }

    p {
      margin: 0;
      font-size: 0.875rem;
      color: ${(props) => props.theme['gray-500']};
    }
  }
`;

interface IPropsPercentValue {
  upValue: boolean;
}

export const PercentValue = styled.span<IPropsPercentValue>`
  display: flex;
  justify-content: center;
  text-align: center;

  flex-direction: row;
  align-items: center;
  gap: 0.25rem;


  background: ${(props) => (props.upValue ? '#E8FFEA' : '#FFE8E8')};
  color: ${(props) =>
    props.upValue ? props.theme['success-300'] : props.theme['danger-300']};
  padding: 0.75rem 1rem;
  border-radius: 8px;

  width: 100%;
  // max-width: 300px;
  font-weight: 400;
  font-size: 1.5rem;
`;

export const PercentValueCumulative = styled.span<IPropsPercentValue>`
  display: inline-flex;
  justify-content: center; /* centraliza horizontalmente */
  align-items: center;     /* centraliza verticalmente */
  gap: 0.25rem;

  background: ${(props) => (props.upValue ? '#E8FFEA' : '#FFE8E8')};
  color: ${(props) =>
    props.upValue ? props.theme['success-300'] : props.theme['danger-300']};
  padding: 0.10rem 0.4rem;
  border-radius: 4px;

  font-weight: 400;
  font-size: 0.85rem;

  /* width: 100%; limita o fundo ao conteúdo */
  width: fit-content; /* limita o fundo ao conteúdo */
`;


export const FiltersDate = styled(ScrollContainer)`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  max-width: fit-content;
  white-space: nowrap;
  margin-left: 0;
  margin-top: 0;
`;

export interface IPropsFilterSelect {
  isSelected: boolean;
}

export const FilterSelect = styled.button<IPropsFilterSelect>`
  all: unset;

  font-weight: 500;
  font-style: 0.875rem;
  color: ${(props) => props.theme['gray-100']};

  ${(props) =>
    props.isSelected &&
    css`
      color: #EC6643;
      text-decoration: none;
    `}
`;

export const StyledQuoteTable = styled.div`
  width: 100%;
  max-width: 300px;
  height: auto;
  max-height: 270px; /* ↓ Menor altura máxima 235px */
  margin-top: 0;
  margin-right: 0;
  box-shadow: 1px 1px 6px 0px rgba(48, 63, 75, 0.42);
  border-radius: 8px;
  padding: 0.2rem 0.5rem 0.5rem 0.5rem ;

  table {
    width: 100%;
    border-spacing: 0;
    font-size: 0.85rem; /* ↓ Fonte menor */
    color: ${(props) => props.theme['gray-500']};

    thead {
      font-weight: 600;
      
      border-bottom: 1px solid var(--Gray-gray-100,rgb(184, 185, 187));
    }

    th{
      padding: 0.4rem 0.4rem; /* ↓ Menos espaço interno */
      text-align: center;
    }
    
    td {
      padding: 0.4rem 0.4rem; /* ↓ Menos espaço interno */
      text-align: center;
      // border-left: 1px solid ${(props) => props.theme['gray-200']};
      // border-right: 1px solid ${(props) => props.theme['gray-200']};
      border-bottom: 1px solid var(--Gray-gray-100,rgb(184, 185, 187));
    }

    tbody tr:not(:last-child) {
      border-bottom: 1px solid ${(props) => props.theme['gray-200']};
    }

    td:first-child {
      font-weight: 500;
    }
  }
`;

export const HeaderTopBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center; /* <-- isso centraliza horizontalmente */
  gap: 5rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center; /* <-- centraliza no modo coluna (mobile) */
  }
`;

export const CardHeaderValue = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  border-top: 1px solid #EC6643;
  min-width: 12rem;
  width: auto;
  border-radius: 8px;
  padding: 0.5rem;
  box-shadow: 1px 1px 6px 0px rgba(48, 63, 75, 0.42);
  margin-bottom: 0.25rem;
  h6 {
    font-size: 1.25rem;
    color: ${(props) => props.theme['gray-500']};
    margin-bottom: 0.25rem;
  }

  strong {
    font-weight: 600;
    font-size: 1.25rem;
    color: ${(props) => props.theme['gray-500']};
    margin-bottom: 0.5rem;
  }
  span {
    font-size: 1rem;
    font-weight: 400;
    color: ${(props) => props.theme['gray-400']};
  }
`;
